import React from 'react';
import { Site } from '@99designs/site-navigation/lib/Site';
import { Onboarder } from '../components/Onboarder';
import { config } from '../website/config';
import type { Role } from '@99designs/site-navigation/consts';

interface Props {
    role: Role;
    site: Site;
    exchangeRate: number;
    onPageChange: (title: string, description: string) => void;
}

export function WebOnboarderPage({ role, site, exchangeRate, onPageChange }: Props) {
    return (
        <Onboarder
            config={config(role, site, exchangeRate)}
            role={role}
            onPageChange={onPageChange}
        />
    );
}
